(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid-quick-view"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('[data-qv-section]');
  if (!sections.length) return;

  sections.forEach(function(section) {
    var modalBackdrop = section.querySelector('[data-qv-modal]');
    if (!modalBackdrop) return;

    var modalImage = modalBackdrop.querySelector('[data-qv-modal-image]');
    var modalTitle = modalBackdrop.querySelector('[data-qv-modal-title]');
    var modalMeta = modalBackdrop.querySelector('[data-qv-modal-meta]');
    var modalDesc = modalBackdrop.querySelector('[data-qv-modal-description]');
    var modalLink = modalBackdrop.querySelector('[data-qv-modal-link]');
    var modalLinkLabel = modalBackdrop.querySelector('[data-qv-modal-link-label]');

    function openModal(data) {
      if (!data) return;

      if (data.image) modalImage.src = data.image;
      modalTitle.textContent = data.title || '';
      modalMeta.textContent = data.meta || '';
      modalDesc.textContent = data.description || '';

      if (data.link) {
        modalLink.href = data.link;
        modalLinkLabel.textContent = data.linkLabel || 'Learn more';
        modalLink.style.display = 'inline-flex';
      } else {
        modalLink.style.display = 'none';
      }

      modalBackdrop.classList.add('is-active');
      modalBackdrop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modalBackdrop.classList.remove('is-active');
      modalBackdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    modalBackdrop.addEventListener('click', function(e) {
      if (e.target === modalBackdrop || e.target.hasAttribute('data-qv-close')) {
        closeModal();
      }
    });

    document.addEventListener('keyup', function(e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    var items = section.querySelectorAll('.quick-view-grid__item');
    items.forEach(function(item) {
      item.addEventListener('click', function() {
        var data = {
          image: item.getAttribute('data-qv-image'),
          title: item.getAttribute('data-qv-title'),
          meta: item.getAttribute('data-qv-meta'),
          description: item.getAttribute('data-qv-description'),
          link: item.getAttribute('data-qv-link'),
          linkLabel: item.getAttribute('data-qv-link-label')
        };
        openModal(data);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-grid-quick-view-image-only"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('[data-masonry-io-section]');
  if (!sections.length) return;

  sections.forEach(function(section) {
    var modalBackdrop = section.querySelector('[data-masonry-io-modal]');
    if (!modalBackdrop) return;

    var modalImage = modalBackdrop.querySelector('[data-masonry-io-modal-image]');
    var closeButton = modalBackdrop.querySelector('[data-masonry-io-close]');
    var prevButton = modalBackdrop.querySelector('[data-masonry-io-prev]');
    var nextButton = modalBackdrop.querySelector('[data-masonry-io-next]');

    var items = section.querySelectorAll('.masonry-io-item');
    var filterButtons = section.querySelectorAll('[data-masonry-io-filter]');
    var grid = section.querySelector('.masonry-io-grid');
    var isAnimatingFilter = false;
    var fadeDuration = 250;
    var currentIndex = -1;

    // Initial state: show all items
    items.forEach(function(item) {
      item.style.display = '';
      item.classList.add('is-visible');
    });

    function getVisibleItems() {
      var visible = [];
      items.forEach(function(item) {
        if (item.style.display !== 'none') {
          visible.push(item);
        }
      });
      return visible;
    }

    function openModal(imageSrc) {
      if (!imageSrc) return;
      modalImage.src = imageSrc;
      modalBackdrop.classList.add('is-active');
      modalBackdrop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function openModalForIndex(index) {
      var visibleItems = getVisibleItems();
      if (!visibleItems.length) return;

      if (index < 0) {
        index = visibleItems.length - 1;
      } else if (index >= visibleItems.length) {
        index = 0;
      }

      currentIndex = index;
      var item = visibleItems[currentIndex];
      var imageSrc = item.getAttribute('data-masonry-io-image');
      openModal(imageSrc);
    }

    function closeModal() {
      modalBackdrop.classList.remove('is-active');
      modalBackdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    modalBackdrop.addEventListener('click', function(e) {
      if (e.target === modalBackdrop || e.target.hasAttribute('data-masonry-io-close')) {
        closeModal();
      }
    });

    document.addEventListener('keyup', function(e) {
      if (modalBackdrop.classList.contains('is-active')) {
        if (e.key === 'Escape') {
          closeModal();
        } else if (e.key === 'ArrowRight') {
          openModalForIndex(currentIndex + 1);
        } else if (e.key === 'ArrowLeft') {
          openModalForIndex(currentIndex - 1);
        }
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.stopPropagation();
        openModalForIndex(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.stopPropagation();
        openModalForIndex(currentIndex + 1);
      });
    }

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        var visibleItems = getVisibleItems();
        var index = visibleItems.indexOf(item);

        // Fallback: if somehow not found, base on full items list
        if (index === -1) {
          visibleItems = Array.prototype.slice.call(items);
          index = visibleItems.indexOf(item);
        }

        openModalForIndex(index);
      });
    });

    function getFiltersForItem(item) {
      var filtersAttr = item.getAttribute('data-masonry-io-filters') || '';
      var parts = filtersAttr.split(',');
      var result = [];
      for (var i = 0; i < parts.length; i++) {
        var trimmed = parts[i].trim();
        if (trimmed.length) result.push(trimmed);
      }
      return result;
    }

    function findFirstRect(item, firstRects) {
      for (var i = 0; i < firstRects.length; i++) {
        if (firstRects[i].item === item) {
          return firstRects[i].rect;
        }
      }
      return null;
    }

    function applyFilter(filter) {
      if (isAnimatingFilter) return;
      isAnimatingFilter = true;

      // Snapshot "first" positions of currently visible items
      var firstRects = [];
      items.forEach(function(item) {
        if (item.style.display !== 'none') {
          firstRects.push({
            item: item,
            rect: item.getBoundingClientRect()
          });
        }
      });

      var willShow = [];
      var willHide = [];

      items.forEach(function(item) {
        var filters = getFiltersForItem(item);
        var matches = (filter === 'all' || filter === '' || filters.indexOf(filter) !== -1);

        if (matches) {
          willShow.push(item);
        } else {
          willHide.push(item);
        }
      });

      // Fade out items to be hidden, but keep them in layout during fade
      for (var i = 0; i < willHide.length; i++) {
        var hideItem = willHide[i];
        if (hideItem.style.display !== 'none') {
          hideItem.classList.remove('is-visible');
        }
      }

      setTimeout(function() {
        // Remove hidden items from layout
        for (var i = 0; i < willHide.length; i++) {
          willHide[i].style.display = 'none';
        }

        // Ensure items to show are visible in layout
        for (var j = 0; j < willShow.length; j++) {
          var showItemEl = willShow[j];
          if (showItemEl.style.display === 'none') {
            showItemEl.style.display = '';
            showItemEl.style.opacity = '0';
            showItemEl.style.transform = 'translateY(15px)';
          }
        }

        // Force reflow
        if (grid) {
          grid.offsetWidth;
        }

        // FLIP: animate remaining items into new positions
        for (var k = 0; k < willShow.length; k++) {
          (function() {
            var item = willShow[k];
            var lastRect = item.getBoundingClientRect();
            var firstRect = findFirstRect(item, firstRects);

            if (firstRect) {
              var dx = firstRect.left - lastRect.left;
              var dy = firstRect.top - lastRect.top;

              item.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
              item.style.opacity = '1';

              requestAnimationFrame(function() {
                item.classList.add('is-visible');
                item.style.transform = '';
              });
            } else {
              // New item in this filter
              requestAnimationFrame(function() {
                item.classList.add('is-visible');
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
              });
            }
          })();
        }

        // Reset currentIndex so next click starts from new visible set
        currentIndex = -1;
        isAnimatingFilter = false;
      }, fadeDuration);
    }

    if (filterButtons.length) {
      filterButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          var filter = button.getAttribute('data-masonry-io-filter');

          filterButtons.forEach(function(btn) {
            btn.classList.remove('is-active');
          });
          button.classList.add('is-active');

          applyFilter(filter);
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-grid-quick-view"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('[data-masonry-qv-section]');
  if (!sections.length) return;

  sections.forEach(function(section) {
    var modalBackdrop = section.querySelector('[data-masonry-qv-modal]');
    if (!modalBackdrop) return;

    var modalImage = modalBackdrop.querySelector('[data-masonry-qv-modal-image]');
    var modalTitle = modalBackdrop.querySelector('[data-masonry-qv-modal-title]');
    var modalMeta = modalBackdrop.querySelector('[data-masonry-qv-modal-meta]');
    var modalDesc = modalBackdrop.querySelector('[data-masonry-qv-modal-description]');
    var modalLink = modalBackdrop.querySelector('[data-masonry-qv-modal-link]');
    var modalLinkLabel = modalBackdrop.querySelector('[data-masonry-qv-modal-link-label]');

    var items = section.querySelectorAll('.masonry-qv-item');
    var filterButtons = section.querySelectorAll('[data-masonry-qv-filter]');

    // Initialize all items as visible on load
    items.forEach(function(item) {
      item.classList.add('is-visible');
    });

    function openModal(data) {
      if (!data) return;

      if (data.image) {
        modalImage.src = data.image;
      }

      modalTitle.textContent = data.title || '';
      modalMeta.textContent = data.meta || '';
      modalDesc.textContent = data.description || '';

      if (data.link) {
        modalLink.href = data.link;
        modalLinkLabel.textContent = data.linkLabel || 'Learn more';
        modalLink.style.display = 'inline-flex';
      } else {
        modalLink.style.display = 'none';
      }

      modalBackdrop.classList.add('is-active');
      modalBackdrop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modalBackdrop.classList.remove('is-active');
      modalBackdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    modalBackdrop.addEventListener('click', function(e) {
      if (e.target === modalBackdrop || e.target.hasAttribute('data-masonry-qv-close')) {
        closeModal();
      }
    });

    document.addEventListener('keyup', function(e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        var data = {
          image: item.getAttribute('data-masonry-qv-image'),
          title: item.getAttribute('data-masonry-qv-title'),
          meta: item.getAttribute('data-masonry-qv-meta'),
          description: item.getAttribute('data-masonry-qv-description'),
          link: item.getAttribute('data-masonry-qv-link'),
          linkLabel: item.getAttribute('data-masonry-qv-link-label')
        };
        openModal(data);
      });
    });

    function showItem(item) {
      // make sure it's in the layout before animating
      item.style.display = '';
      // force reflow for transition to kick in
      void item.offsetWidth;
      item.classList.add('is-visible');
    }

    function hideItem(item) {
      item.classList.remove('is-visible');
      // after transition, remove from layout
      setTimeout(function() {
        item.style.display = 'none';
      }, 250);
    }

    function applyFilter(filter) {
      items.forEach(function(item) {
        var filtersAttr = item.getAttribute('data-masonry-qv-filters') || '';
        var filters = filtersAttr
          .split(',')
          .map(function(f) { return f.trim(); })
          .filter(function(f) { return f.length; });

        var matches = (filter === 'all' || filter === '' || filters.indexOf(filter) !== -1);

        if (matches) {
          showItem(item);
        } else {
          hideItem(item);
        }
      });
    }

    if (filterButtons.length) {
      filterButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          var filter = button.getAttribute('data-masonry-qv-filter');

          filterButtons.forEach(function(btn) {
            btn.classList.remove('is-active');
          });
          button.classList.add('is-active');

          applyFilter(filter);
        });
      });

      // Default filter = "all"
      applyFilter('all');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
